import { Form } from 'factorial-form'

import folders from 'modules/documents/store/collections/folders'
import { ALL_TYPES } from 'modules/documents/store/models/Document'
import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'
import { FIXED_LEAVE_IDENTIFIERS } from 'modules/timeoff/store/models/LeaveType'

interface CustomFieldForDocument {
  value: any
  resource_id: string
}

export type CustomFields = CustomFieldForDocument[]

class LeaveDocumentForm extends Form {
  constructor(values: {}) {
    super(values, {
      file: 'file',
      type: 'string',
      leave_id: 'number',
      employee_id: 'number',
      public: 'boolean',
      folder_id: 'number',
      custom_fields: 'any',
    })
  }

  documentType(leave: Leave): string | null | undefined {
    const identifier = leave.leaveType?.attributes.identifier

    return identifier === FIXED_LEAVE_IDENTIFIERS.sick ? ALL_TYPES.sick_leave : null
  }

  setDocumentValues(leave: Leave, customFields: CustomFields = []) {
    this.setValues({
      type: this.documentType(leave),
      leave_id: leave.attributes.id,
      employee_id: leaveEmployee(leave).attributes.id,
      public: true,
      folder_id: folders.sickFolder?.id,
      custom_fields: customFields,
    })
  }
}

export default LeaveDocumentForm
